var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.username
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "row no-gutters px-5 pt-lg-0 pt-2 align-items-center",
          },
          [
            _c("div", { staticClass: "col-12 col-lg-7" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("file.messages.selectApplicationToUpload.0")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-8 col-md-5 mb-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    "form-container form-group-material form-group-material-no-label mt-md-3 mx-0 px-0",
                },
                [
                  _c("select2", {
                    attrs: {
                      name: "application-selection",
                      value: _vm.applicationId,
                      data: _vm.mappedApplications,
                      options: _vm.applicationSelectOptions,
                      "format-data": _vm.formatData,
                    },
                    on: { change: _vm.handleApplicationChange },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.applicationId
              ? _c("upload-documents", {
                  staticClass: "w-100",
                  attrs: {
                    uploading: _vm.uploadingDocument,
                    "application-id": _vm.applicationId,
                    "client-username": _vm.username,
                    "uploading-succeeded": _vm.uploadingSucceeded,
                    applications: _vm.applications,
                  },
                  on: { "upload-documents": _vm.handleUploadDocuments },
                })
              : _c(
                  "div",
                  {
                    staticClass:
                      "upload-file-info w-100 d-flex flex-column align-items-center",
                  },
                  [
                    _c("div", { staticClass: "upload-file-icon" }, [
                      _c("i", {
                        staticClass: "fa fa-folder-open",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("file.messages.selectApplicationToUpload.1")
                          ) +
                          "\n      "
                      ),
                    ]),
                  ]
                ),
          ],
          1
        ),
      ])
    : _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c(
            "add-client-modal",
            _vm._b(
              {
                ref: "addClient",
                attrs: { id: "add-client-from-files" },
                on: { hidden: _vm.resetModalData },
              },
              "add-client-modal",
              _vm.modalData,
              false
            )
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "justify-content-center d-flex" },
            [
              _c("empty-application-handler", {
                attrs: {
                  "client-profile-id": _vm.clientProfileId,
                  profile: _vm.profile,
                },
                on: { create: _vm.handleCreateApplication },
              }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }